export enum ReconnectType {
  PENDING = 'PENDING',
  FORCE = 'FORCE',
  NONE = 'NONE',
}
